import { Field } from "@components/field/field";
import { Checkbox } from "antd";
import React from "react";
import { FormattedMessage } from "react-intl";
import { SharedProps } from "../../general/sections/challengeBasicSettingsCard";
import { CardSubtitle, SectionWrapper } from "../challengeAdvancedTabStyle";

interface ActivityMultipliersSettingsProps extends SharedProps {
    multiplierTypes: string[];
    isActivityMultipliersEnabled: boolean;
}

export const ActivityMultipliersSettings = ({ multiplierTypes, isActivityMultipliersEnabled, ...sharedProps }: ActivityMultipliersSettingsProps) => {
    const [showMultipliers, setShowMultipliers] = React.useState(isActivityMultipliersEnabled);

    if (!multiplierTypes.length) {
        return null;
    }

    const filteredMutliplierTypes = multiplierTypes.filter(type => ["walking", "running", "swimming", "workout", "cycling"].includes(type));

    return (
        <SectionWrapper>
            <CardSubtitle><FormattedMessage id="activityMultipliers.title" /></CardSubtitle>
            <Checkbox
                checked={showMultipliers}
                onChange={() => setShowMultipliers(!showMultipliers)}
            >
                <FormattedMessage id="activityMultipliers.enable" />
            </Checkbox>
            {showMultipliers && (
                filteredMutliplierTypes.map(type => (
                    <Field
                        key={`activityMultipliers.${type}`}
                        numberType
                        id={`activityMultipliers.${type}`}
                        initialValue={1}
                        label={<FormattedMessage id={`activityMultipliers.${type}`} />}
                        min={0}
                        name={["activityMultipliers", type]}
                        step={0.1}
                        {...sharedProps}
                    />
                ))
            )}
        </SectionWrapper>
    );
};
